import { AiOutlineCreditCard } from "react-icons/ai";
import { StepBar } from "../common/steps";
import { useNavigate } from "react-router-dom";

export default function SetPlan() {
  const navigate = useNavigate();

  const handleNext = () => {
    navigate("/feed");
  };

  return (
    <div>
      <StepBar
        steps={[
          { label: "Profile", status: "complete" },
          { label: "Wallet", status: "complete" },
          { label: "Team", status: "complete" },
          { label: "Plan", status: "current" },
        ]}
      />
      <div className="rounded max-w-xs min-w-xs p-5 bg-slate-100">
        <h1 className="text-2xl font-bold mb-5 flex items-center">
          <AiOutlineCreditCard size={40} className="mr-2" />
          Your Plan
        </h1>
        <p className="mb-5">
          You're on the <a className="text-purpler text-bold">pilot</a> plan.
          Congrats!
        </p>
        <p className="mb-5">
          Now that you've finished creating your Ribbon profile, you're ready to
          create and receive your first achievements.
        </p>
        <button
          onClick={handleNext}
          className="bg-purpler text-white font-bold py-2 px-4 rounded"
        >
          Finish
        </button>
      </div>
    </div>
  );
}
